import request from '../utils/request'
import qs from 'qs'
import { getTeamCode } from '@/utils/auth'

import { commonConfig } from '../utils/config'
const { apiUrl, apiHetaoDomain } = commonConfig

// 获取订单管理列表
export async function getLinkList(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent/link/list?${qs.stringify(params)}`)
}

export async function addProduct(params) {
  return request(`${apiUrl}/ug-agent-back/v1/token/agent/link`, params)
}

export async function editProduct(params) {
  return request(`${apiUrl}/ug-agent-back/v1/token/agent/link`, params)
}

export async function getCourseList(platform = '') {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/course/team/list/status?teamCode=${getTeamCode()}&platform=${platform}`)
}

export async function getTeamList(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent/team/composition?${qs.stringify(params)}`)
}

export async function getChannelList(teamCode, teamCodeList = '') {
  const teamCodeListStr = teamCodeList ? `&teamCodeList=${teamCodeList}` : ''
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent/channel/list?teamCode=${teamCode}${teamCodeListStr}`)
}

// 查询批量生成的推广链接
export async function groupByBatchNo(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent/link/groupByBatchNo?${qs.stringify(params)}`)
}

/**
 * 停用推广链接
 * @author Awen_liang1002
 * @date 2023-04-17
 * @param {any} params
 * @returns {any}
 */
export async function deactivatePromotedLinks(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent/link/disable?${qs.stringify(params)}`, {
    type: 'PUT'
  })
}

/**
 * 启用推广链接
 * @author Awen_liang1002
 * @date 2023-04-17
 * @param {any} params
 * @returns {any}
 */
export async function enablePromotedLinks(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent/link/enable?${qs.stringify(params)}`, {
    type: 'PUT',
  })
}

/**
 * 批量禁用推广链接
 * @author Awen_liang1002
 * @date 2023-04-18
 * @param {any} params
 * @returns {any}
 */
export async function batchDeactivatePromotedLinks(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent/link/batchDisable?${qs.stringify(params)}`, {
    type: 'PUT',
  })
}
